import { useMutation, useQuery } from 'react-query';
import queryGetEnvelopes from './queries/getEnvelopes';
import mutationCreateEnvelope from './mutations/createEnvelope';
import mutationCreateDownloadCode from './mutations/createDownloadCode';
import mutationDeprogramEnvelopes from './mutations/deprogramEnvelopes';
import mutationUpdateDownloadCode from './mutations/updateDownloadCode';
import queryGetDownloadCodes from './queries/getDownloadCodes';

const actionsEnvelopes = {
    // Envelopes
    // get envelopes
    getEnvelopes: (params, enabled) => useQuery(queryGetEnvelopes(params, enabled)),

    // create envelope
    createEnvelope: (onSuccess, onError) => useMutation(mutationCreateEnvelope(onSuccess, onError)),

    // Deprogram Envelopes
    deprogramEnvelopes: (onSuccess, onError) => useMutation(mutationDeprogramEnvelopes(onSuccess, onError)),

    // Download Codes
    // get download codes
    getDownloadCodes: (enabled, params) => useQuery(queryGetDownloadCodes(enabled, params)),

    // create download code
    createDownloadCode: (onSuccess, onError) => useMutation(mutationCreateDownloadCode(onSuccess, onError)),

    // update download code
    updateDownloadCode: (onSuccess, onError) => useMutation(mutationUpdateDownloadCode(onSuccess, onError))

};

export default actionsEnvelopes;